import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as action from '../../redux/actions';
import SolicitarPedido from '../Modals/solicitarpedido';
import FaltaDireccion from '../Modals/faltadireccion';
import swal from 'sweetalert';
import Button from '../button';
import ModalPortal from '../../portals/ModalPortal';
import Modal from '../modal';
import OrderConfirmation from '../Modals/order-confirmation';

class Checkout extends Component {
   constructor(props) {
      super(props);
      this.state = {
         checkout: false,
         comment: '',
         showModal: false,
         currentModalPage: 1,
         generatedOrder: '',
         userEmail: '',
      };
   }

   componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);

      if (
         Object.keys(this.props.direccion).length !== 0 &&
         this.props.direccion.constructor === Object
      ) {
         document.getElementById('name').value =
            this.props.direccion.name || '';
         document.getElementById('last_name').value =
            this.props.direccion.last_name || '';
         document.getElementById('address').value =
            this.props.direccion.address || '';
         document.getElementById('city').value =
            this.props.direccion.city || '';
         document.getElementById('zip').value =
            this.props.direccion.zip_code || '';
         document.getElementById('phone').value =
            this.props.direccion.phone || '';
         document.getElementById('email').value =
            this.props.direccion.email || '';
      } else if (this.props.auth) {
         const nombre = this.props.user.Nombre.split(' ');
         document.getElementById('name').value = nombre[0];
         document.getElementById('last_name').value = nombre[1];
         document.getElementById('address').value =
            this.props.user.domicilio || '';
         document.getElementById('city').value = this.props.user.ciudad || '';
         document.getElementById('zip').value =
            this.props.user.codigo_postal || '';
         document.getElementById('phone').value =
            this.props.user.tel_principal_uno || '';
         document.getElementById('email').value = this.props.user.email;
      }
   }

   componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
   }

   handlePay(event) {
      if (this.props.carrito.length) {
         this.handleShowModal();
      } else {
         swal({ text: 'El carrito se encuentra vacío', buttons: 'Continuar' });
      }
   }

   handleShowModal() {
      this.setState({ showModal: !this.state.showModal });
      const modalWillClose = !this.state.showModal;
      if (modalWillClose) this.setState({ currentModalPage: 1 });
   }

   handleNextModalPage(generatedOrder, userEmail) {
      this.setState({ currentModalPage: 2, generatedOrder, userEmail });
      this.props.onClearCart();
   }

   handleKeyDown = event => {
      if (event.key === 'Escape' && this.state.showModal) {
         this.handleShowModal();
      }
   };

   handleAdd(event) {
      event.preventDefault();
      var direction = {
         name: event.target.name.value,
         last_name: event.target.last_name.value,
         address: event.target.address.value,
         city: event.target.city.value,
         zip_code: event.target.zip.value,
         phone: event.target.phone.value,
         email: event.target.email.value,
         addressName: event.target.addressName.value,
      };
      this.props.dispatch(action.save_Direction(direction));
   }

   render() {
      return (
         <div>
            <div className="column">
               <div className="btn-checkout">
                  <div className="checkout-large align-center row-responsive ">
                     <a
                        id="btn-newAddress"
                        onClick={() => (window.location = '/catalogo')}
                     >
                        <Button theme="dark">Seguir comprando</Button>
                     </a>
                     <a>
                        <Button
                           id="btn-checkout"
                           onClick={this.handlePay.bind(this)}
                        >
                           Solicitar pedido
                        </Button>
                     </a>
                  </div>
               </div>
               {this.state.showModal && (
                  <ModalPortal>
                     <Modal onClose={this.handleShowModal.bind(this)}>
                        {this.state.currentModalPage === 1 && (
                           <SolicitarPedido
                              comment={this.state.comment}
                              onNext={this.handleNextModalPage.bind(this)}
                           />
                        )}
                        {this.state.currentModalPage === 2 && (
                           <OrderConfirmation
                              order={this.state.generatedOrder}
                              userEmail={this.state.userEmail}
                              onClose={this.handleShowModal.bind(this)}
                           />
                        )}
                     </Modal>
                  </ModalPortal>
               )}

               <FaltaDireccion />
            </div>
         </div>
      );
   }
}
function mapStateToProps(state) {
   return {
      auth: state.auth,
      user: state.user,
      direccion: state.direccion,
      carrito: state.carrito,
   };
}
export default connect(mapStateToProps)(Checkout);



// WEBPACK FOOTER //
// ./src/components/Cart/checkout.js